<section class="flex h-screen items-center justify-center dark:text-gray-300">
  <div class="text-center">
    <h1 class="mb-5 text-6xl font-bold text-blue-500 dark:text-red-600">404</h1>
    <h2 class="mb-4 text-4xl font-bold">
      Oops, sorry we can't find that page!
    </h2>
    <p class="mb-8 text-lg">
      Either something went wrong or the page doesn't exist anymore.
    </p>
    <a routerLink="/" class="text-blue-500 hover:underline dark:text-red-600"
      >Go back to Homepage</a
    >
  </div>
</section>
